/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Button, Modal } from '@atoms';

import s from './styles.module.less';

const ContentModuleModal = ({
  children,
  onSubmit,
  onCancel,
  onDelete,
  okText,
  cancelText = 'CANCEL',
  deleteText = 'DELETE',
  ...props
}) => (
  <Modal.withHeroImage
    className={s.contentModal}
    footer={
      <>
        <Button key="submit" type="primary" onClick={onSubmit}>
          {okText}
        </Button>
        <Button key="back" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button key="delete" disabled={!onDelete} onClick={onDelete} className="delete-button">
          {deleteText}
        </Button>
      </>
    }
    {...props}
  >
    {children}
  </Modal.withHeroImage>
);

export default ContentModuleModal;
